import { nonEmpty } from "../nonEmpty";

interface SearchBrandContext {
  allBrands?: boolean;
  brand?: unknown;
  maker?: unknown;
}

/** Сохраняет прежнее правило проценки: «Lada (Лада)» → «Lada». */
export function firstBrandToken(value: string): string {
  return value.trim().split(/\s+/, 1)[0] ?? "";
}

function brandToken(value: unknown): string {
  return typeof value === "string" ? firstBrandToken(value) : "";
}

/** Явный выбор всех брендов важнее авто; выбранный бренд важнее марки авто. */
export function resolveSearchBrand({ allBrands, brand, maker }: SearchBrandContext): string | undefined {
  if (allBrands) return undefined;
  return nonEmpty(brandToken(brand)) ?? nonEmpty(brandToken(maker));
}
